import React, { useState, useEffect } from "react";
import "./../../../../assets/css/purchase/form.css";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import {
    deleteData,
    getAlert,
    insertData,
    parseCurrency,
    updateData,
    getData,
} from "../../../../utils/SamuiUtils";

const Form = ({ callInitialize, mode, name, formData, setFormData, selectedData }) => {
    const [initialFormData, setInitialFormData] = useState({});

    useEffect(() => {
        const compId = localStorage.getItem("company");
        if (compId) {
            setFormData((prevData) => ({ ...prevData, comp_id: compId }));
        }
    }, [setFormData]);

    useEffect(() => {
        if (mode === "I") {
            const initialData = {
                comp_id: parseCurrency(window.localStorage.getItem("company"), 10),
                ProdCat_Id: 0,
                ProdCat_Name: "",
                ProdCat_Status: "Y",
            };
            setFormData(initialData);
            setInitialFormData(initialData);
        } else if (mode === "U") {
            const initialData = {
                comp_id: parseCurrency(selectedData.Comp_Id, 10),
                ProdCat_Id: parseCurrency(selectedData.ProdCat_Id, 10),
                ProdCat_Name: selectedData.ProdCat_Name,
                ProdCat_Status: selectedData.ProdCat_Status,
            };
            setFormData(initialData);
            setInitialFormData(initialData);
        }
    }, [mode, setFormData, selectedData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleInsert = async () => {
        try {
            const { ProdCat_Id, ...dataToInsert } = formData;
            const fields = Object.keys(dataToInsert).join(", ");
            const values = Object.values(dataToInsert);
            const res = await insertData("Tb_Set_ProdCategory", fields, values);
            if (res?.status === "OK") {
                getAlert("OK", "บันทึกสำเร็จ");
                callInitialize();
            } else {
                getAlert("FAILED", res?.message || "ไม่สามารถบันทึกข้อมูลได้");
            }
        } catch (error) {
            getAlert("FAILED", "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว");
        }
    };

    const formatValues = (data) => {
        const { ProdCat_Id, ...rest } = data;
        return rest;
    };

    const handleUpdate = async () => {
        try {
            const where = { ProdCat_Id: formData.ProdCat_Id };
            const values = formatValues(formData);
            const res = await updateData("Tb_Set_ProdCategory", values, where);
            if (res) {
                getAlert("OK", "อัปเดตข้อมูลสำเร็จ");
                callInitialize();
            }
        } catch (error) {
            getAlert("FAILED", "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว");
            return null;
        }
    };

    const handleDelete = async () => {
        try {
            const compId = parseCurrency(window.localStorage.getItem("company"), 10);
            const prodCatId = parseCurrency(selectedData.ProdCat_Id, 10);
            const linkedTypes = await getData(
                "Tb_Set_ItmType",
                `ProdCat_Id = ${prodCatId} AND Comp_Id = ${compId}`
            );
            if (linkedTypes && linkedTypes.length > 0) {
                getAlert("FAILED", "ไม่สามารถลบหมวดหมู่สินค้าได้ เนื่องจากมีประเภทค่าใช้จ่ายถูกผูกอยู่");
                return;
            }

            getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
                if (isConfirm) {
                    await deleteData("Tb_Set_ProdCategory", `WHERE ProdCat_Id = ${prodCatId} AND Comp_Id = ${compId}`);
                    getAlert("OK", "ลบข้อมูลสำเร็จ");
                    await callInitialize();
                }
            });
        } catch (error) {
            getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
        }
    };

    const confirmAndSubmit = async () => {
        try {
            getAlert('C_DIALOG', 'ยืนยันการบันทึกข้อมูล', async (isConfirm) => {
                if (isConfirm) {
                    await handleSubmit();
                }
            });
        } catch (error) {
            console.error(error);
        }
    };

    const confirmAndUpdate = async () => {
        try {
            getAlert('C_DIALOG', 'ยืนยันการแก้ไขข้อมูล', async (isConfirm) => {
                if (isConfirm) {
                    await handleUpdate();
                    await callInitialize();
                    window.location.href = '/prodcategory';
                }
            });
        } catch (error) {
            console.error(error);
        }
    };

    const handleSubmit = async (e) => {
        try {
            if (mode === "I") {
                await handleInsert();
            } else if (mode === "U") {
                await handleUpdate();
            }
            await callInitialize();
            setFormData({ comp_id: parseCurrency(window.localStorage.getItem("company"), 10), ProdCat_Id: 0, ProdCat_Name: "", ProdCat_Status: "Y" });
        } catch (error) {
            getAlert("WARNING", "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว");
            return null;
        }
    };

    return (
        <form>
            <Breadcrumbs
                isShowStatus={mode === "U"}
                items={[
                    { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
                    { name: name, url: "/prodcategory" },
                    { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
                ]}
            />
            <div className="container py-4">
                <div className="card shadow-sm">
                    <div className="card-body">
                        <h5 className="mb-3 border-bottom pb-2">{name}</h5>
                        <div className="row g-3">
                            <div className="col-6">
                                <label>ชื่อหมวดหมู่สินค้า</label>
                                <input type="text" className="form-control" name="ProdCat_Name" value={formData.ProdCat_Name || ""} onChange={handleChange} maxLength={50} />
                            </div>
                            <div className="col-6">
                                <label>สถานะ</label>
                                <select className="form-select" name="ProdCat_Status" value={formData.ProdCat_Status || "Y"} onChange={handleChange}>
                                    <option value="Y">ใช้งาน</option>
                                    <option value="N">ไม่ใช้งาน</option>
                                </select>
                            </div>
                        </div>

                        <div className="row mt-4">
                            {mode !== "I" ? (
                                <div className="d-flex justify-content-between align-items-center">
                                    <button onClick={handleDelete} type="button" className="btn btn-danger btn-lg">ลบ</button>
                                    <div className="d-flex justify-content-end gap-2">
                                        <button onClick={() => (window.location.href = "/prodcategory")} type="button" className="btn btn-dark btn-lg">ยกเลิก (ESC)</button>
                                        <button onClick={confirmAndUpdate} type="button" className="btn btn-warning text-white btn-lg">บันทึก (F10)</button>
                                    </div>
                                </div>
                            ) : (
                                <div className="d-flex justify-content-end gap-2">
                                    <button onClick={() => (window.location.href = "/prodcategory")} type="button" className="btn btn-dark btn-lg">ยกเลิก (ESC)</button>
                                    <button onClick={confirmAndSubmit} type="button" className="btn btn-warning text-white btn-lg">บันทึก (F10)</button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default Form;
